import React from "react";
import Navbar from "./Navbar";
import PageTitle from './components/PageTitle';


const AttendingDashboard = () => (
  <div>
    <PageTitle title="Attending Dashboard" description="Manage evaluations and view resident information" />
    <Navbar pageTitle="Attending Dashboard" />
    <div className="container py-4">
      <h2>Welcome, Attending!</h2>
      <p>This is your dashboard.</p>
    </div>
  </div>
);

export default AttendingDashboard; 